module.exports = __webpack_public_path__ + "img/help4-1.4695f7f0.png";